import { get } from "js-cookie"

const getters = {
    userInfo: state => state.userInfo
}

export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js